import { TokenRequest } from "./types/request/TokenRequest";
import { IComponentGroup } from "./component/ComponentGroup";
import Component from "./component/Component";
import { GooglePaySdkPaymentData, isGooglePaySdkPaymentData } from "./payment-request/types/GooglePaySdkPaymentData";
import { isApplePayPaymentResponse, isGooglePayPaymentResponse, PaymentResponse } from "./payment-request/types/PaymentResponse";
import Controller from "./controller/Controller";
import IntegrationError from "./IntegrationError";
import { ControllerProvider } from "./controller/ControllerProvider";

export class CreateTokenRequestFactory {

  constructor(
    private controllerProvider: ControllerProvider
  ) {
  }

  createRequest(componentOrToken: IComponentGroup | Component | GooglePaySdkPaymentData | PaymentResponse, tokenData: TokenRequest = {}): {
    request: TokenRequest,
    controller: Controller
  } {
    if (!componentOrToken) {
      throw new IntegrationError("Provide Component, Component Group or a digital wallet response to create a Shift4 token.")
    }

    if ('_controllerId' in componentOrToken && this.controllerProvider.has(componentOrToken._controllerId)) {
      const controller = this.controllerProvider.get(componentOrToken._controllerId)
      const request = tokenData;
      return { controller, request }
    }

    if (isGooglePaySdkPaymentData(componentOrToken)) {
      const controller = this.controllerProvider.create();
      const request: TokenRequest = { ...tokenData, googlePay: { token: componentOrToken.paymentMethodData.tokenizationData.token } };
      return { controller, request }
    }

    if (isGooglePayPaymentResponse(componentOrToken)) {
      const controller = this.controllerProvider.create();
      const request: TokenRequest = { ...tokenData, googlePay: { token: componentOrToken.details.paymentMethodData.tokenizationData.token } };
      return { controller, request }
    }

    if (isApplePayPaymentResponse(componentOrToken)) {
      const controller = this.controllerProvider.create();
      const request: TokenRequest = { ...tokenData, applePay: { token: componentOrToken.details.token.paymentData } };
      return { controller, request }
    }

    throw new IntegrationError("Provide Component, Component Group or a digital wallet response to create a Shift4 token.")
  }
}